"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicList = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var StyledUL = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n"], ["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n"])));
var StyledLI = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n"], ["\n"])));
var StyledA = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: 18px;\n    display: inline-block;\n    cursor: pointer;\n    /* !important required as SRW overrides A */\n    color: ", ";\n    opacity: 0.65;\n\n    &:hover {\n        opacity: 1;\n    }\n"], ["\n    font-size: ", ";\n    line-height: 18px;\n    display: inline-block;\n    cursor: pointer;\n    /* !important required as SRW overrides A */\n    color: ", ";\n    opacity: 0.65;\n\n    &:hover {\n        opacity: 1;\n    }\n"])), Theme_1.FontSize, Theme_1.important(Theme_1.Color.Grey.G70));
StyledA.displayName = "a";
var BasicList = /** @class */ (function (_super) {
    __extends(BasicList, _super);
    function BasicList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasicList.prototype.render = function () {
        var _this = this;
        if (this.props.Data) {
            return (React.createElement(StyledUL, null, this.props.Data.map(function (item, index) { return React.createElement(StyledLI, { key: index },
                React.createElement(StyledA, { onClick: _this.props.OnClick.bind(_this, item) }, item)); })));
        }
        else {
            return null;
        }
    };
    return BasicList;
}(React.Component));
exports.BasicList = BasicList;
var templateObject_1, templateObject_2, templateObject_3;
